/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { Link } from 'react-router-dom'
// Utilities
import Header from '../../components/header/index'
import Hero from '../../components/heros/index'
import Container from '../../components/container'
import Footer from '../../components/footer'
import Title from '../../components/title'

const Index = () => {
    Title('Other Hosting - StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='Other Hosting' description='View all of the non game-server hosting options below' />
            </div>
            <section className='games py-28'>
                <Container>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16'>
                        <div className='minecraft bg-primary-light text-center rounded-md'>
                            <Link to='/other/discord' className='block w-full p-6'>
                                <h1 className='text-xl text-gray-100 font-medium'>Discord Bot</h1>
                            </Link>
                        </div>
                    <div className='minecraft bg-primary-light text-center rounded-md'>
                            <Link to='/other/web' className='block w-full p-6'>
                                <h1 className='text-xl text-gray-100 font-medium'>Web Hosting</h1>
                            </Link>
                        </div>
                    </div>
                </Container>
            </section>
            <Footer />
        </main>
    )
}

export default Index